<div
  class="card-wrapper gradient-border d-flex"
  [ngClass]="
    type() == CardType.THIRED_TYPE
      ? 'small-height d-flex align-items-center'
      : ''
  "
>
  <span *ngIf="withIndicator()" class="indicator">{{ indicator() }}</span>
  <div
    class="d-flex align-items-center content"
    [ngClass]="type() == CardType.THIRED_TYPE ? 'align-items-center' : ''"
  >
    <div class="svg-img" *ngIf="icon()">
      <svg-icon [name]="icon()"></svg-icon>
    </div>
    <div class="text">
      <h3 class="head">{{ cardTitle() }}</h3>
      <!-- [ngClass]="type() == CardType.SECOND_TYPE ? 'fs-9' : 'fs-13'" -->
      <p *ngIf="desc()" class="description">
        {{ desc() }}
      </p>
    </div>
  </div>
</div>
